export interface ConnectionData {
  Meeting: {
    MeetingId: string;
    MediaPlacement: {
      AudioHostUrl: string;
      AudioFallbackUrl: string;
      SignalingUrl: string;
      TurnControlUrl: string;
    };
  };
  Attendee: {
    AttendeeId: string;
    JoinToken: string;
  };
}

export interface StartCallRequest {
  sessionId: string;
  featureName?: string;
  queueId?: string;
}

export interface StartCallResponse {
  contactId: string;
  connectionData: ConnectionData;
  participantToken: string;
}

export enum ConnectErrorType {
  CAPACITY_EXCEEDED = 'CAPACITY_EXCEEDED',
  INVALID_REQUEST = 'INVALID_REQUEST',
  CONNECT_ERROR = 'CONNECT_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
}

export interface ConnectError {
  type: ConnectErrorType;
  message: string;
  retryable: boolean;
  originalError?: Error;
}

export class ConnectErrorClass extends Error implements ConnectError {
  type: ConnectErrorType;
  retryable: boolean;
  originalError?: Error;

  constructor(type: ConnectErrorType, message: string, retryable: boolean, originalError?: Error) {
    super(message);
    this.name = 'ConnectError';
    this.type = type;
    this.retryable = retryable;
    this.originalError = originalError;
  }
}
